import { render, staticRenderFns } from "./ServicesView.vue?vue&type=template&id=76f8a7e8&"
import script from "./ServicesView.vue?vue&type=script&lang=js&"
export * from "./ServicesView.vue?vue&type=script&lang=js&"
import style0 from "./ServicesView.vue?vue&type=style&index=0&id=76f8a7e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports